import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changePower, getProducts } from "../../store/reducers/filterSlice";
import { withTranslation } from "react-i18next";

class Powers extends React.Component {
  state = {
    closed: [],
  };

  constructor(props) {
    super(props);

    this.toggle = (powerClass) => {
      let closed = this.state.closed;
      const index = closed.indexOf(powerClass);

      if (index === -1) {
        closed.push(powerClass);
      } else {
        closed.splice(index, 1);
      }

      this.setState({ closed: closed });
    };

    this.isOpened = (powerClass) => {
      return this.state.closed.indexOf(powerClass) < 0;
    };

    this.powerChanged = (powerClass, frequency) => () => {
      let frequencies = this.props.frequency;
      let oldPowerClass = this.props.class;

      if (
        this.buttonIsSelected(powerClass, frequency) &&
        frequencies.length == 1
      ) {
        return;
      }

      if (oldPowerClass != powerClass) {
        frequencies = [];
      }

      if (this.buttonIsSelected(powerClass, frequency)) {
        frequencies = frequencies.filter((frq) => frq != frequency);
      } else {
        if (!frequency.startsWith("DC")) {
          frequencies = frequencies.filter((frq) => frq.startsWith("DC"));
        }

        frequencies = [...frequencies, frequency];
      }

      this.props.changePower({
        class: powerClass,
        frequency: frequencies,
      });
    };

    this.buttonIsSelected = (powerClass, frequency) => {
      const selectedClass = this.props.class == powerClass ? true : false;
      const selectedFrequency = this.props.frequency.includes(frequency);

      return selectedClass && selectedFrequency;
    };
  }

  getPowerTypeLabel = (powerClass) => {
    switch (powerClass) {
      case "metricISO":
        return this.props.t
          ? this.props.t("Standard International (SI)")
          : "AC";
      case "metricUS":
        return this.props.t ? this.props.t("US Standard (US)") : "DC";
      default:
        return powerClass;
    }
  };

  render() {
    const { t } = this.props;
    return (
      <>
        {Object.entries(this.props.powers).map((power, i) => (
          <li data-filter-part="item-container" key={power[0]}>
            <span
              className={`radio-container ${
                this.isOpened(power[0]) ? " selected" : ""
              }`}
              onClick={() => {
                this.toggle(power[0]);
              }}
            >
              <a>{this.getPowerTypeLabel(power[0])}</a>
            </span>
            <div
              className={`radio-wrapper ${
                this.isOpened(power[0]) ? " selected" : ""
              }`}
            >
              <label className="sublabel">{this.props.t("Power supply")}</label>
              <ul
                className={`powersupply l2 ${
                  this.isOpened(power[0]) ? " selected" : ""
                }`}
                data-filter-part="item-children-container"
                data-class={power[0]}
              >
                {power[1].map((frequency, j) => (
                  <li key={j}>
                    <input
                      type="checkbox"
                      checked={this.buttonIsSelected(power[0], frequency.value)}
                      id={"f-power-" + power[0] + "-" + frequency.value}
                      onChange={this.powerChanged(power[0], frequency.value)}
                      value={frequency.value}
                    />
                    <label
                      htmlFor={"f-power-" + power[0] + "-" + frequency.value}
                    >
                      {frequency.value}
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          </li>
        ))}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    class: state.filter.request.class,
    frequency: state.filter.request.frequency,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changePower: (args) => (dispatch) => {
        dispatch(changePower(args));
        dispatch(getProducts());
      },
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Powers));
